import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CurrencyFacade } from '@rx-applications/clientsite/shared/currency/data-access';
import { Currency } from '@rx-applications/shared/data-access';
import { Observable, switchMap } from 'rxjs';
import { translationProvider, TRANSLATION_SCOPE } from './assets/i18n/translation.provider';

@Component({
  selector: 'rx-currency-selector',
  templateUrl: './currency-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [translationProvider],
})
export class CurrencySelectorComponent implements OnInit {
  @Input() selectedCurrency$: Observable<string>;

  @Output() optionSelected = new EventEmitter<string>();

  currencies$: Observable<Currency[]>;
  selectedCurrencyObj$: Observable<Currency | undefined>;
  TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  constructor(private currencyFacade: CurrencyFacade) {}

  ngOnInit(): void {
    this.currencies$ = this.currencyFacade.currencies$;
    this.selectedCurrencyObj$ = this.selectedCurrency$.pipe(
      switchMap((selectedCurrency) => this.currencyFacade.currencyObjectByCode$(selectedCurrency))
    );
  }

  optionSelectedClick(currencyCode: string) {
    this.optionSelected.emit(currencyCode);
  }
}
